import { render, staticRenderFns } from "./FateItemInformation.vue?vue&type=template&id=69742a5a&"
import script from "./FateItemInformation.vue?vue&type=script&lang=js&"
export * from "./FateItemInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports